export default "__VITE_ASSET__CAwIW3tO__"